// copy of the account identifier pattern in packages/integrations/snowflake/shared/src/components.ts
// TODO(INT-612): placeholder, Miguel decides whether legacy dotted account
// locators are accepted. The secret names in `secret-manager.ts` rely on
// this pattern having exactly one `-`.
/** `ORGNAME-ACCOUNTNAME`: upper-case letters and digits, and `_` in the
 * account name. Kept free of imports, so the MCP server spec can use it
 * without loading the install components. */
export const ACCOUNT_IDENTIFIER_PATTERN = /^[0-9A-Z]+-[0-9A-Z_]+$/;
